import { InjectionToken } from '@angular/core';

export const SERVER_ENDPOINT = new InjectionToken<string>('SERVER_ENDPOINT');
